import { ChangeEvent } from 'react';
import Grid from '@mui/material/Grid';
import PortsAutocomplete from '../../../../autocompletewithapi/PortsAutocomplete';
import Customdatepicker from '../../../../customdatepicker/customdatepicker';
import { PackingListBasicInterface } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';
import CustomTextField from '../../../../CustomTextInput';

const PortDetails = ({
    errors,
    payload,
    updateField
}: PackingListBasicInterface) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <PortsAutocomplete
                                errorCondition={
                                    errors?.portOfLoadingId.length > 0
                                }
                                helperText={
                                    errors?.portOfLoadingId.length > 0
                                        ? errors?.portOfLoadingId
                                        : undefined
                                }
                                id='quotation-portOfLoading'
                                label='Port of Loading'
                                name='portOfLoadingId'
                                updateField={updateField}
                                nameValue='portOfLoadingValue'
                                value={payload.portOfLoadingValue}
                            />
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4 lg:mt-0'>
                                <PortsAutocomplete
                                    errorCondition={
                                        errors?.portOfDischargeId.length > 0
                                    }
                                    helperText={
                                        errors?.portOfDischargeId.length > 0
                                            ? errors?.portOfDischargeId
                                            : undefined
                                    }
                                    id='quotation-portOfDischarge'
                                    label='Port of Discharge'
                                    name='portOfDischargeId'
                                    updateField={updateField}
                                    nameValue='portOfDischargeValue'
                                    value={payload.portOfDischargeValue}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4 lg:mt-0'>
                                <Customdatepicker
                                    value={payload?.dateOfDeparture || null}
                                    id='quotation-issuedDate'
                                    label='Date of Departure'
                                    name='dateOfDeparture'
                                    updateField={updateField}
                                    error={errors?.dateOfDeparture.length > 0}
                                    helperText={
                                        errors?.dateOfDeparture.length > 0
                                            ? errors?.dateOfDeparture
                                            : undefined
                                    }
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4 lg:mt-0'>
                                <CustomTextField
                                    error={errors?.finalDestination.length > 0}
                                    helperText={
                                        errors?.finalDestination.length > 0
                                            ? errors?.finalDestination
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-finalDestination'
                                    label='Final Destination'
                                    name='finalDestination'
                                    value={payload?.finalDestination}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'finalDestination',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
};

export default PortDetails;
